import axios from "axios";
import { toast } from "react-toastify";
import { v7 as uuidv7 } from "uuid";
import { BlockUserInput } from "@jamezz/react-components";

type HttpOptions = Partial<{
  showSpinner: boolean;
  showToastSuccess: boolean;
  showToastError: boolean;
  toastSuccessMessage: string;
  toastErrorMessage: string;
}>;

export const DefaultOptions = {
  showSpinner: true,
  showToastSuccess: true,
  showToastError: true,
  toastSuccessMessage: "Success",
  toastErrorMessage: "Error",
};

export const DefaultOptionsGet = {
  showSpinner: false,
  showToastSuccess: false,
  showToastError: true,
  toastSuccessMessage: "",
  toastErrorMessage: "Error",
};

export const _get = (url: string, data: FormData | null = null, options: HttpOptions | null = null) => {
  const o = { ...DefaultOptionsGet, ...options };
  return _request("get", url, data, o);
};

export const _post = (url: string, data: FormData | object | null = null, options: HttpOptions | null = null) => {
  return _request("post", url, data, options);
};

export const _put = (url: string, data: FormData | null = null, options: HttpOptions | null = null) => {
  return _request("put", url, data, options);
};

export const _patch = (url: string, data: FormData | null = null, options: HttpOptions | null = null) => {
  return _request("patch", url, data, options);
};

export const _delete = (url: string, data: FormData | null = null, options: HttpOptions | null = null) => {
  return _request("delete", url, data, options);
};

export const _request = (
  method: string,
  url: string,
  data: FormData | object | null = null,
  options: HttpOptions | null = null
) => {
  return new Promise((resolve, reject) => {
    const o = { ...DefaultOptions, ...options };
    doRequest(method, url, data, resolve, reject, o);
  });
};

export const doRequest = (
  method: string,
  url: string,
  data: FormData | object | null,
  resolve: ((value: any) => void) | null = null,
  reject: ((value: any) => void) | null = null,
  options: any | null = null,
  axiosConfig: any = null,
  setCancelToken: any = null
) => {
  method = method.toLowerCase();
  if (options == null) {
    options = DefaultOptions;
  }
  let blockingUuid = "";
  if (options.showSpinner) {
    blockingUuid = uuidv7();
    BlockUserInput.blockingStarted(blockingUuid);
  }

  if (data && method == "patch") {
    if (data instanceof FormData) {
      data.set("_method", "PATCH");
    } else {
      data["_method"] = "PATCH";
    }
  }

  const source = axios.CancelToken.source();
  if (setCancelToken) {
    axiosConfig = { ...axiosConfig, cancelToken: source.token };
    setCancelToken(source);
  }
  const uninterceptedAxiosInstance = axios.create(axiosConfig);
  // @ts-ignore
  return uninterceptedAxiosInstance({ method: method == "patch" ? "post" : method, url, data }) //, headers: { "Content-Type": "multipart/form-data" } })
    .then((response) => {
      if (options.showSpinner) {
        BlockUserInput.blockingStopped(blockingUuid);
      }

      if (response.data.status === "error") {
        if (options.showToastError) {
          toast.error(response.data.message);
        }
        if (reject) {
          reject(response);
        }
        return;
      }

      if (options.showToastSuccess) {
        toast.success(options.toastSuccessMessage);
      }
      if (resolve) {
        resolve(response);
      }
    })
    .catch((err) => {
      if (options.showSpinner) {
        BlockUserInput.blockingStopped(blockingUuid);
      }
      if (options.showToastError) {
        toast.error(options.toastErrorMessage);
      }
      if (reject) {
        reject(err);
      }
    });
};
